<template>
  <div class="article-delete">
    <div>
      <img src="../assets/images/error.png" alt="" class="error-img"/>
    </div>
    <div>
      <p class="error-tip" v-if="type==='deleted'">{{$t('lang.articleDeleted')}}</p>
      <p class="error-tip" v-else-if="type==='error'">{{$t('lang.error')}}</p>
      <p class="error-tip" v-else>{{$t('lang.notFound')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    type () {
      return this.$route.query.type
    }
  }
}
</script>

<style scoped>
  .article-delete {
    height: 100vh;
    background-color: #F2F2F2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .error-img {
    width: 3.75rem;
    height: 3.75rem;
  }
  .error-tip {
    color: #919ca3;
    font-size: .875rem;
    margin: 2rem 0;
  }
</style>
